import * as React from 'react';
import { css, styled } from '../../theme-provider';
import { CardHeaderChevron } from './card-header-chevron';
import { CardHeaderCheckbox } from './card-header-checkbox';
import { CardTitle } from './card-title';
import { useCardContext } from '../card';
export const CardHeaderWrapper = styled.div.withConfig({ displayName: "CardHeaderWrapper", componentId: "sc-1mpflw3" }) `display:flex;justify-content:space-between;:focus{outline:none;}${({ role }) => (role === 'button' || role === 'option') &&
    css `
			::after {
				content: '';
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				cursor: pointer;
			}
		`}`;
const CardHeaderIcon = ({ dataTestId }) => {
    const { type, isActive = false } = useCardContext();
    if (type === 'collapsible') {
        return React.createElement(CardHeaderChevron, { isOpen: isActive, dataTestId: dataTestId });
    }
    if (type === 'selectable')
        return React.createElement(CardHeaderCheckbox, { isSelected: isActive, dataTestId: dataTestId });
    return null;
};
export const CardHeader = ({ title, children, }) => {
    const getRoleByType = (type) => {
        if (type === 'collapsible') {
            return 'button';
        }
        if (type === 'selectable') {
            return 'option';
        }
        return undefined;
    };
    const { type, dataTestId, isActive = false, role = getRoleByType(type), ariaLabel, } = useCardContext();
    const isSelected = type === 'selectable' ? isActive : undefined;
    const isExpanded = type === 'collapsible' ? isActive : undefined;
    return (React.createElement(CardHeaderWrapper, { "aria-label": ariaLabel, tabIndex: type !== 'default' ? 0 : undefined, role: role, "aria-selected": isSelected, "aria-expanded": isExpanded },
        React.createElement(CardTitle, { title: title }),
        React.createElement(CardHeaderIcon, { dataTestId: dataTestId }),
        children && React.createElement(React.Fragment, null, children)));
};
